module.exports = __webpack_public_path__ + "img/so2_en.164451b9.jpg";